import React, { Component } from 'react';
import './TermsAndConditionsPopup.css'; // For styling (see below)

class TermsAndConditionsPopup extends Component {
  handleAgree = () => {
    if (this.props.onAgree) {
      this.props.onAgree();
    }
  };

  handleCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  render() {
    const {termsAndConditionList} = this.props;
    return (
      <div className="popup-overlay">
        <div className="popup-container">
          <h2 className="ml-10">Terms & Conditions</h2>
          <div className="terms-list">
            {termsAndConditionList.map((text, index) => (
              <div key={index} className="term-item">
                <strong>{text.id}.</strong> {text.text}
              </div>
            ))}
          </div>
          <div className="popup-actions">
            <button className="btn cancel-btn" onClick={this.handleCancel}>Cancel</button>
            <button className="btn agree-btn" onClick={this.handleAgree}>Agree</button>
          </div>
        </div>
      </div>
    );
  }
}

export default TermsAndConditionsPopup;
